
<style >
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');


.app{
 
}

.roboto-100 {
  font-family: "Roboto", sans-serif;
  font-optical-sizing: auto;
  font-weight: 100;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}
/*
p,
a {
  letter-spacing: 2px;
  font-weight: 100 !Important;
  line-height: 2 !important;
}
*/
.auth-container p,
.auth-container a {
  letter-spacing: 2px;
  font-weight: 100;
}


.ai_summary {
  font-size: 18px;
  line-height: 1.8;
  font-weight: 300 !important;
}

.auth-container {
  max-width: 600px;
  margin-left:  auto;
  margin-right: auto;
  max-width: auto;
  padding: 2rem;
  width: 96%;
  
 
 
}

.auth-container h3 {
  margin-bottom: 1rem;
  text-align: center;
}

.auth-container p {
  margin-top: 1rem;
  text-align: center;
}

.btn-login {
 
  border-radius: 3px !important;
  box-shadow: none !important;
  
  height: 47px !important;
  width: 100%;
 
  
}

 

.google-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 47px !important;
  padding: 12px 14px;
  border-radius: 3px;
  margin-top:4px;

  border: 1px solid rgba(0,0,0,0.12);
  background: #ffffff!important;
  color: #111827!important;

  font: 600 14px/1 system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  letter-spacing: 0.2px;

  cursor: pointer;
  user-select: none;

  transition: transform 0.04s ease, box-shadow 0.18s ease, border-color 0.18s ease;
 
}

/*
.google-btn:hover {
 
}

.google-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}

.google-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.25), 0 6px 18px rgba(0,0,0,0.10);
}
*/


.google-btn__icon {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  
  background: #fff;
  border-radius: 8px;
}

.google-btn__text {
  white-space: nowrap;
}

</style>



<style scoped>
.btn {
 height: 55px !important;
}

</style>



 







<template   >
  <v-app class="app ">

 
    
    <!-- Wait for Firebase to finish checking user -->
    <div v-if="loadingUser && !isPublicRoute"   class="d-flex align-center justify-center"
    :style="{
      height: '100vh',
    
    }"
    >
      <!--<div style="height:100vh; width:100vw; background-color:var(--v-theme-background)"></div>-->
      <v-progress-circular
        indeterminate
        color="#f26e2e"
        bg-color="transparent"
        size="70"
      />
    </div>

    <div v-else-if="isPublicRoute" class="app-shell">
      <v-main class="content">
        <router-view />
      </v-main>
    </div>
  
 

    <!-- --------------------------------------------------
    | Show sign-in/register form if not signed in 
    --------------------------------------------------- -->
    <div v-else-if="!user" class="app-shell pt-9 " style="background-color: transparent!important;">

    <v-main style="  background-color: #fafafa!important;" class="content">
 
      <div style="max-width: 600px; width: 94%; margin: auto; background-color: transparents!important;" class="mb-13">
        <v-sheet  class="pa-0"  style="  width:100%!important; background-color: transparent!important;" color="transparent">
        

        <v-form @submit.prevent="handleAuth" class="pa-3" style="  width:100%!important " >
          <v-row style=" " >

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style="text-align: center;"> 
                <p 
                  style="
                 
                    padding:5px 9px;
                    margin:auto;
                    font-weight:900!important;
                    font-size:31px;
                    line-height:1!important;
                    display:inline-block;
                  
                  "
                  class="mb-6"
                >
                  <img :src="logo" width="100px">
                </p>
            </v-col>

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style=" "> 
              <h2 class="mb-3">{{ isRegister ? "Register" : "Login" }}</h2>
            </v-col>


            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0" style=" "> 
              <v-text-field   variant="outlined" class="login-input " v-model="firstName" label="First Name" requiwhite  style="    "   />
            </v-col>

            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-text-field   variant="outlined" class="login-input" v-model="lastName" label="Last Name (optional)"  style="  "  />
            </v-col>
        
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input" v-model="email" label="Email" type="email" requiwhite  style="   "  />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input"  v-model="password" label="Password" type="password" requiwhite />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field v-if="isRegister" variant="outlined" class="login-input" v-model="confirmPassword" label="Confirm Password" type="password" requiwhite  style="  width:100%!important "  />
            </v-col>
            
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn mt-1 btn-login" type="submit" variant="tonal" style="background-color: var(--accent-primary)!important; color: var(--v-primary)"   block>
                {{ isRegister ? "Register" : "Login" }}
              </v-btn>
            </v-col>
 
    
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn google-btn" @click="signInWithGoogle"  variant="outlined"  block style="">
                <span class="google-btn__icon" aria-hidden="true">
                
                  <svg width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.671 32.66 29.225 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4c-7.682 0-14.35 4.337-17.694 10.691z"/>
                    <path fill="#4CAF50" d="M24 44c5.623 0 10.743-2.053 14.625-5.406l-6.744-5.703C29.873 34.347 27.093 36 24 36c-5.203 0-9.635-3.314-11.28-7.946l-6.52 5.025C9.505 39.556 16.227 44 24 44z"/>
                    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.325-2.273 4.279-4.242 5.592l.003-.002 6.744 5.703C36.75 40.27 44 35 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                  </svg>

                </span>
                <span class="google-btn__text">Sign in with Google</span>
              </v-btn>
            </v-col>


            
            <v-col v-if="isRegister" cols="12" md="12" class="ma-0 pt-0 pb-0 mt-9"> 
              <v-checkbox v-model="termsAndPolicy">
                <template #label>
                  <div>
                    I agree to the 
                    <a href="#" @click.prevent="showTerms = true" style="color: var(--v-primary); font-weight: 400!important;">
                      Terms & Conditions
                    </a>
                    and the 
                    <a href="#" @click.prevent="showPrivacy = true"  style="color: var(--v-primary); font-weight: 400!important;">
                      Privacy Policy
                    </a>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="emailConsent">
                <template #label>
                  <div>
                    I agree to receive marketing emails from test_name. I understand I can unsubscribe at any time.
                  </div>
                </template>
              </v-checkbox>
            </v-col>


          </v-row>
          
        
  
        </v-form>
    
   
        </v-sheet>




        <div class="mt-13" style="text-align: center;">

          <p style="margin: auto;">
            {{ isRegister ? "Already have an account?" : "Don't have an account?" }}
            <a href="#" @click.prevent="isRegister = !isRegister" style=" font-weight:bold!important; color: var(--v-primary)"   >
              {{ isRegister ? "Login" : "Register" }}
            </a>
          </p>

          <Terms v-model="showTerms" />
          <Privacy v-model="showPrivacy" />
        </div>


      </div>

    </v-main>  
    </div>
    <!-- --------------------------------------------------
    | 
    --------------------------------------------------- -->



    <!-- --------------------------------------------------
    | Show app if signed in  v-else
    --------------------------------------------------- -->
    <div v-else-if="user && !user.emailVerified" class="auth-container" style="text-align: center; ">
      <p>Please verify your email to continue.</p>

      <v-btn
        variant="outlined"
        size="small"
        class="mt-3  "
        :loading="sending"
        :disabled="sending"
        @click="resendVerification"
        style="margin:auto; height:50px "
      >
        {{ sending ? 'Sending…' : 'Resend verification email' }}
      </v-btn>

      <p v-if="sent" class="mt-2 text-success">
        Verification email sent.
      </p>

    <v-main style="  background-color: #fafafa!important;" class="content">
 
      <div style="max-width: 600px; width: 94%; margin: auto; background-color: transparents!important;" class="mb-13">
        <v-sheet  class="pa-0"  style="  width:100%!important; background-color: transparent!important;" color="transparent">
        

        <v-form @submit.prevent="handleAuth" class="pa-3" style="  width:100%!important " >
          <v-row style=" " >

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style="text-align: center;"> 
                <p 
                  style="
                 
                    padding:5px 9px;
                    margin:auto;
                    font-weight:900!important;
                    font-size:31px;
                    line-height:1!important;
                    display:inline-block;
                  
                  "
                  class="mb-6"
                >
                  <img :src="logo" width="100px">
                </p>
            </v-col>

            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0" style=" "> 
              <h2 class="mb-3">{{ isRegister ? "Register" : "Login" }}</h2>
            </v-col>


            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0" style=" "> 
              <v-text-field   variant="outlined" class="login-input " v-model="firstName" label="First Name" requiwhite  style="    "   />
            </v-col>

            <v-col v-if="isRegister" cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-text-field   variant="outlined" class="login-input" v-model="lastName" label="Last Name (optional)"  style="  "  />
            </v-col>
        
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input" v-model="email" label="Email" type="email" requiwhite  style="   "  />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field variant="outlined" class="login-input"  v-model="password" label="Password" type="password" requiwhite />
            </v-col>
      
            <v-col cols="12" md="12" class="ma-0 pt-0 pb-0"> 
              <v-text-field v-if="isRegister" variant="outlined" class="login-input" v-model="confirmPassword" label="Confirm Password" type="password" requiwhite  style="  width:100%!important "  />
            </v-col>
            
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn mt-1 btn-login" type="submit" variant="tonal" style="background-color: var(--accent-primary)!important; color: var(--v-primary)"   block>
                {{ isRegister ? "Register" : "Login" }}
              </v-btn>
            </v-col>
 
    
            <v-col cols="12" md="6" class="ma-0 pt-0 pb-0"> 
              <v-btn class="btn google-btn" @click="signInWithGoogle"  variant="outlined"  block style="">
                <span class="google-btn__icon" aria-hidden="true">
                
                  <svg width="18" height="18" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.671 32.66 29.225 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
                    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.968 3.032l5.657-5.657C34.95 6.053 29.727 4 24 4c-7.682 0-14.35 4.337-17.694 10.691z"/>
                    <path fill="#4CAF50" d="M24 44c5.623 0 10.743-2.053 14.625-5.406l-6.744-5.703C29.873 34.347 27.093 36 24 36c-5.203 0-9.635-3.314-11.28-7.946l-6.52 5.025C9.505 39.556 16.227 44 24 44z"/>
                    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.325-2.273 4.279-4.242 5.592l.003-.002 6.744 5.703C36.75 40.27 44 35 44 24c0-1.341-.138-2.65-.389-3.917z"/>
                  </svg>

                </span>
                <span class="google-btn__text">Sign in with Google</span>
              </v-btn>
            </v-col>


            
            <v-col v-if="isRegister" cols="12" md="12" class="ma-0 pt-0 pb-0 mt-9"> 
              <v-checkbox v-model="termsAndPolicy">
                <template #label>
                  <div>
                    I agree to the 
                    <a href="#" @click.prevent="showTerms = true" style="color: var(--v-primary); font-weight: 400!important;">
                      Terms & Conditions
                    </a>
                    and the 
                    <a href="#" @click.prevent="showPrivacy = true"  style="color: var(--v-primary); font-weight: 400!important;">
                      Privacy Policy
                    </a>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="emailConsent">
                <template #label>
                  <div>
                    I agree to receive marketing emails from test_name. I understand I can unsubscribe at any time.
                  </div>
                </template>
              </v-checkbox>
            </v-col>


          </v-row>
          
        
  
        </v-form>
    
   
        </v-sheet>




        <div class="mt-13" style="text-align: center;">

          <p style="margin: auto;">
            {{ isRegister ? "Already have an account?" : "Don't have an account?" }}
            <a href="#" @click.prevent="isRegister = !isRegister" style=" font-weight:bold!important; color: var(--v-primary)"   >
              {{ isRegister ? "Login" : "Register" }}
            </a>
          </p>

          <Terms v-model="showTerms" />
          <Privacy v-model="showPrivacy" />
        </div>


      </div>

    </v-main>  
    </div>


 

    <div v-else style=" "  class="app-shell">
   
      <v-main style="   " class="content">

        
        <router-view />
      
      </v-main>
      <SideBar v-if="isDesktopNav && !route.path.includes('site')" :onSignOut="signOut" />
      <BottomNav v-if="!isDesktopNav && !route.path.includes('site')" :onSignOut="signOut" />
      <!--<BottomNav/>
      
      <SideBar v-if="isDesktopNav && !route.path.includes('site')" :onSignOut="signOut" />
      <BottomNav v-if="!isDesktopNav && !route.path.includes('site')" :onSignOut="signOut" />
      
      -->


 

      
    </div>
    <!-- --------------------------------------------------
    | 
    --------------------------------------------------- -->
    
  </v-app>
  
</template>







<script setup>
/* --------------------------------------------------
| Imports
-------------------------------------------------- */
import { computed, ref, onBeforeUnmount, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { loadTemplates } from '@/stores/websiteTemplatesStore'
//import { API_BASE_URL } from '@/stores/appConfig'


import {
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  sendEmailVerification,
  signOut as firebaseSignOut
} from 'firebase/auth'


import { doc, setDoc } from "firebase/firestore"
import { db } from "@/firebase"

import { auth } from '@/firebase'
import { serverTimestamp } from "firebase/firestore"

/* Components */
import SideBar from './components/SideBar.vue'
import BottomNav from './components/BottomNav.vue'
import Terms from './components/general/Terms.vue'
import Privacy from './components/general/Privacy.vue'

import logo from '@/assets/logo.png'





const { hostname } = window.location
const API_BASE_URL = (() => {
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3000/api'
  }
  if (hostname === 'quotastic.ca') {
    return 'https://api.quotastic.ca/api'
  }
  return 'https://api-staging.quotastic.ca/api'
})()














const route = useRoute()
const isPublicRoute = computed(() => route.meta?.public === true)
const NAV_BREAKPOINT = 900
const isDesktopNav = ref(
  typeof window !== 'undefined' ? window.innerWidth >= NAV_BREAKPOINT : false
)

const updateNavigationLayout = () => {
  if (typeof window === 'undefined') return

  isDesktopNav.value = window.innerWidth >= NAV_BREAKPOINT
}






const showTerms = ref(false)
const showPrivacy = ref(false)

const termsAndPolicy = ref(false)
const emailConsent = ref(false)







/* --------------------------------------------------
| Auth State
-------------------------------------------------- */
const user = ref(null)
const loadingUser = ref(true)

const email = ref('')
const password = ref('')

const firstName = ref('')
const lastName = ref('')
const confirmPassword = ref('')



const isRegister = ref(false)

/* Email verification resend */
const sending = ref(false)
const sent = ref(false)

/* --------------------------------------------------
| Firebase auth listener
-------------------------------------------------- */
onMounted(() => {
  updateNavigationLayout()
  window.addEventListener('resize', updateNavigationLayout)
  loadTemplates()

  onAuthStateChanged(auth, (currentUser) => {
    user.value = currentUser
    loadingUser.value = false
  })
})

onBeforeUnmount(() => {
  if (typeof window === 'undefined') return

  window.removeEventListener('resize', updateNavigationLayout)
})

/* --------------------------------------------------
| Auth actions
-------------------------------------------------- */
const handleAuth = async () => {
  if (!email.value || !password.value) {
    alert('Please enter email and password')
    return
  }

  try {

    // Register new user with email/password if isRegister is true
    if (isRegister.value) {
      
      if (!firstName.value) {
        alert('Please enter first name')
        return
      }

      if(confirmPassword.value !== password.value){
        alert("Passwords do not match")
        return
      }   

      if(!termsAndPolicy.value){
        alert("You must agree to the Terms & Conditions and Privacy Policy to register")
        return
      }

 

      const result = await createUserWithEmailAndPassword(
        auth,
        email.value,
        password.value
      )
      await sendEmailVerification(result.user)

      /*
      var emailOptInDate = ''
      if(emailConsent.value === true){
        emailOptInDate = serverTimestamp()
      }*/
         
      // Create Firestore user document
      await setDoc(doc(db, "users", result.user.uid), {
        email: email.value,
        firstName: firstName.value,
        lastName: lastName.value,
        role: "user",
        createdAt: serverTimestamp(),
        user_id: result.user.uid,

        
      //  termsAndPolicy: termsAndPolicy.value,
        //termsAndPolicyDate:  serverTimestamp(),
        //emailOptIn: emailConsent.value,
        //emailOptInDate: emailOptInDate

        agreeToTerms: true,
        agreeToTermsDate: serverTimestamp(),
        agreeToTermsVersion: "2026-02-18",

        agreeToPrivacy: true,
        agreeToPrivacyDate: serverTimestamp(),
        agreeToPrivacyVersion: "2026-02-18",

        emailOptIn: emailConsent.value,
        emailOptInDate: emailConsent.value ? serverTimestamp() : null

      })



      user.value = result.user
      
    } 

    // Sign in with email/password if not registering
    else {
      const result = await signInWithEmailAndPassword(
        auth,
        email.value,
        password.value
      )
      user.value = result.user

      




console.log('Calling users/upsert...')

const idToken = await result.user.getIdToken()

const response = await fetch(`${API_BASE_URL}/users/upsert`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`
  },
  body: JSON.stringify({
    firebase_uid: result.user.uid,
    email: result.user.email,
    company_id: ""
  })
})

console.log('HTTP Status:', response.status)

const data = await response.json()

console.log('Response Data:', data)








    }

    email.value = ''
    password.value = ''
  } 
  catch (err) {
    alert(err.message)
  }
}

const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider()
    const result = await signInWithPopup(auth, provider)
    user.value = result.user
  } catch (err) {
    alert(err.message)
  }
}

const signOut = async () => {
  try {
    await firebaseSignOut(auth)
    user.value = null
  } catch (err) {
    alert(err.message)
  }
}

/* --------------------------------------------------
| Resend verification email
-------------------------------------------------- */
const resendVerification = async () => {
  if (!auth.currentUser) return

  sending.value = true
  sent.value = false

  try {
    await sendEmailVerification(auth.currentUser)
    sent.value = true
  } catch (err) {
    console.error('Verification email error:', err)
  } finally {
    sending.value = false
  }
}
</script>

   <!--
        <v-btn class="btn-login" @click="signInWithGoogle" block style="">
          Sign in with Google
        </v-btn>-->
